import { DataModel, IdLabel } from './api.models';

export type DashboardAlert = {
	name: string;
	date: string;
};

export type Alert = {
	alertDefinition: any;
	alertTime: string;
	endTime: string;
	firedAt: string;
	firedValues: StationData;
	station: string;
	crop: IdLabel;
};
export type NotificationLog = DataModel & {
	id: string;
	emailDestination: string;
	usernameDestination: string;
	sendTime: string;
	alertDefinition: string;
	message: string;
};

export type ObservationTodayAlert = {
	date: string;
	name: string;
	alertValue: string;
};

export enum Variable {
	TAS = 'tas',
	PR = 'pr',
	HURS = 'hurs',
	SFCWIND = 'sfcwind',
	WGUST = 'wgust',
	IR = 'ir',
	LEAFWETNESS = 'leafwetness',
	PR_CUMULATIVE = 'pr_cumulative',
	TAS_CUMULATIVE = 'tas_cumulative',
	T_HOUR_CUMULATIVE = 't_hour_cumulative',
}

export type StationData = {
	timestamp: string;
	data: {
		[key: string]: number | undefined;
	};
};

export type ObservationList = {
	date: string;
} & {
	[key in Variable]: number;
};

export const enum Layout {
	Card,
	Page,
	Side,
	Table,
}

export type ExpandPayload = {
	id?: string | number;
};
